// // app/[locale]/(cms)/CMSComponents/Components/CurrentLocationComponent.tsx
// 'use client';

// import { useEffect } from 'react';
// import { LocationDetails, useLocationStore } from '@/lib/state-stores/locationStore';
// import {
//   setLocationDetailsInCookies,
//   getLocationDetailsFromCookies,
// } from '@/lib/actions/getCookies';
// import { AddressTypeStrEnum } from '@/types/address';

// type TLatLon = {
//   latitude: number;
//   longitude: number;
// };

// interface AddressComponent {
//   long_name: string;
//   short_name: string;
//   types: string[];
// }

// interface Geometry {
//   location: {
//     lat: number;
//     lng: number;
//   };
// }

// interface GeocodingResult {
//   formatted_address: string;
//   address_components: AddressComponent[];
//   geometry: Geometry;
// }

// interface GeocodingApiResponse {
//   results: GeocodingResult[];
// }

// const fetchLocationDetailsFromGoogle = async ({ latitude, longitude }: TLatLon) => {
//   const response = await fetch(
//     `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}&language=en`,
//   );
//   if (!response.ok) throw new Error('Failed to fetch location details');
//   return response.json();
// };

// const fetchGoogleGeolocation = async () => {
//   const response = await fetch(
//     `https://www.googleapis.com/geolocation/v1/geolocate?key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}`,
//     { method: 'POST' },
//   );
//   if (!response.ok) throw new Error('Failed to fetch location');
//   const data = await response.json();
//   return { latitude: data.location.lat, longitude: data.location.lng };
// };

// const parseLocationDetails = (data: GeocodingApiResponse): LocationDetails => {
//   const results = data?.results?.[0] || {};
//   const location = {
//     latitude: results.geometry?.location.lat,
//     longitude: results.geometry?.location.lng,
//   };
//   const addressComponents = results?.address_components || [];
//   const building =
//     addressComponents.find((component) => component.types?.includes('street_number'))?.long_name ||
//     '';
//   const street =
//     addressComponents.find((component) => component.types?.includes('route'))?.long_name || '';
//   const area =
//     addressComponents.find((component) => component.types?.includes('sublocality'))?.long_name ||
//     '';
//   const city =
//     addressComponents.find(
//       (component) =>
//         component.types?.includes('locality') ||
//         component.types?.includes('administrative_area_level_2'),
//     )?.long_name || '';
//   const province =
//     addressComponents.find((component) => component.types?.includes('administrative_area_level_1'))
//       ?.long_name || '';
//   const country =
//     addressComponents.find((component) => component.types?.includes('country'))?.long_name || '';
//   const zipCode =
//     addressComponents.find((component) => component.types?.includes('postal_code'))?.long_name ||
//     '';
//   const nameAddress = `${building} ${street} ${area} ${city}`;

//   return {
//     location,
//     name: street || nameAddress || results.formatted_address || '',
//     details: results.formatted_address || nameAddress,
//     city,
//     country,
//     type: 3,
//     typeArabicName: AddressTypeStrEnum.Other,
//     typeEnglishName: AddressTypeStrEnum.Other,
//     street,
//     province,
//     zip_code: zipCode,
//   };
// };

// const CurrentLocationComponent = () => {
//   const { locationDetails, setLocationDetails } = useLocationStore();

//   useEffect(() => {
//     // Skip if location already exists in Zustand
//     if (locationDetails?.location.latitude && locationDetails?.location.longitude) return;

//     const initializeLocation = async () => {
//       // Check cookies first
//       const cookieLocation = await getLocationDetailsFromCookies();
//       if (cookieLocation?.location.latitude && cookieLocation?.location.longitude) {
//         setLocationDetails(cookieLocation);
//         return;
//       }

//       // Fetch location
//       if (!navigator.geolocation) {
//         // console.error('Geolocation not supported');
//         try {
//           const googleLocationData = await fetchGoogleGeolocation();
//           const locationData = await fetchLocationDetailsFromGoogle(googleLocationData);
//           const newLocationDetails = parseLocationDetails(locationData);
//           await setLocationDetailsInCookies(newLocationDetails);
//           setLocationDetails(newLocationDetails);
//         } catch (error) {
//           console.error('Error fetching location:', error);
//         }
//         return;
//       }

//       navigator.geolocation.getCurrentPosition(
//         async (position) => {
//           const { latitude, longitude } = position.coords;
//           try {
//             const locationData = await fetchLocationDetailsFromGoogle({ latitude, longitude });
//             const newLocationDetails = parseLocationDetails(locationData);
//             await setLocationDetailsInCookies(newLocationDetails);
//             setLocationDetails(newLocationDetails);
//           } catch (error) {
//             console.error('Error fetching location details:', error);
//           }
//         },
//         async (error) => {
//           console.error('Error obtaining geolocation:', error);
//           try {
//             const googleLocationData = await fetchGoogleGeolocation();
//             const locationData = await fetchLocationDetailsFromGoogle(googleLocationData);
//             const newLocationDetails = parseLocationDetails(locationData);
//             await setLocationDetailsInCookies(newLocationDetails);
//             setLocationDetails(newLocationDetails);
//           } catch (error) {
//             console.error('Error fetching location:', error);
//           }
//         },
//       );
//     };

//     initializeLocation();
//   }, [locationDetails, setLocationDetails]);

//   return null;
// };

// export default CurrentLocationComponent;

'use client';

import { useEffect } from 'react';
import { useLocationStore } from '@/src/lib/state-stores/locationStore';
import Cookies from 'js-cookie';
import { AddressTypeStrEnum } from '@/src/types/address';
import { updateCountryId, refreshServerData } from '@/src/lib/actions';
import { useCountryStore } from '@/src/lib/state-stores/currencyStore';

const DEFAULT_LOCATION = { latitude: 24.7438193, longitude: 46.7039281 };

const fetchLocationDetailsFromGoogle = async ({
  latitude,
  longitude,
}: {
  latitude: number;
  longitude: number;
}) => {
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}&language=en`,
  );
  if (!response.ok) throw new Error('Failed to fetch location details');
  return response.json();
};

const fetchGoogleGeolocation = async () => {
  const response = await fetch(
    `https://www.googleapis.com/geolocation/v1/geolocate?key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}`,
    { method: 'POST' },
  );
  if (!response.ok) throw new Error('Failed to fetch location');
  const data = await response.json();
  return { latitude: data.location.lat, longitude: data.location.lng };
};

const CurrentLocationComponent = () => {
  const { locationDetails, setLocationDetails } = useLocationStore();
  const { setCountryId } = useCountryStore();

  useEffect(() => {
    if (locationDetails?.location?.latitude && locationDetails?.location?.longitude) return;

    const initializeLocation = async () => {
      try {
        // 1. Check cookies
        const cookieLocation = Cookies.get('locationDetails');
        if (cookieLocation) {
          const parsed = JSON.parse(cookieLocation);
          setLocationDetails(parsed);
          return;
        }

        // 2. Browser geolocation
        const getPosition = () =>
          new Promise<GeolocationPosition>((resolve, reject) =>
            navigator.geolocation.getCurrentPosition(resolve, reject),
          );

        let coords = DEFAULT_LOCATION;

        try {
          const pos = await getPosition();
          coords = { latitude: pos.coords.latitude, longitude: pos.coords.longitude };
        } catch {
          // fallback to Google Geolocation API
          try {
            coords = await fetchGoogleGeolocation();
          } catch {
            coords = DEFAULT_LOCATION;
          }
        }

        // 3. Fetch address details
        let newLocationDetails;
        try {
          const locationData = await fetchLocationDetailsFromGoogle(coords);
          newLocationDetails = {
            location: coords,
            name:
              locationData.results?.[0]?.address_components?.find((c: any) =>
                c.types.includes('route'),
              )?.long_name ||
              locationData.results?.[0]?.formatted_address ||
              '',
            details: locationData.results?.[0]?.formatted_address || '',
            city:
              locationData.results?.[0]?.address_components?.find((c: any) =>
                c.types.includes('locality'),
              )?.long_name || '',
            country:
              locationData.results?.[0]?.address_components?.find((c: any) =>
                c.types.includes('country'),
              )?.long_name || '',
            type: 3,
            typeArabicName: AddressTypeStrEnum.Other,
            typeEnglishName: AddressTypeStrEnum.Other,
          };
        } catch {
          newLocationDetails = {
            location: coords,
            name: 'Default Location',
            details: 'Riyadh, Saudi Arabia',
            city: 'Riyadh',
            country: 'Saudi Arabia',
            type: 3,
            typeArabicName: AddressTypeStrEnum.Other,
            typeEnglishName: AddressTypeStrEnum.Other,
          };
        }

        // Save in cookies + store
        Cookies.set('locationDetails', JSON.stringify(newLocationDetails), { expires: 7 });
        setLocationDetails(newLocationDetails);

        // Fetch & set countryId on server and revalidate
        const res = await updateCountryId();
        if (res?.success) {
          setCountryId(res.countryId as any);
        }

        // Force a page re-fetch with new cookies
        await refreshServerData();
      } catch (err) {
        console.error('Location init failed:', err);
      }
    };

    initializeLocation();
  }, [locationDetails, setLocationDetails, setCountryId]);

  return null;
};

export default CurrentLocationComponent;
